import { action } from 'typesafe-actions'
import { FollowUpTypes } from './types'
import { IAxiosResponse, IPaginator, ISearch } from '../root.types'
import { FollowUp } from '../../application/models/followUp/followUp'
// export const resetCreate = () => action(FollowUpTypes.RESET_CREATE)

export const handleStepper = (step: number) => action(FollowUpTypes.HANDLE_STEPPER, { step })

export const handleNextStepperTwo = (step: number) => action(FollowUpTypes.HANDLE_STEPPER_TWO, { step })

export const loadFollowUpRequest = (patientId: string, paginator: IPaginator, filter: ISearch) =>
    action(
        FollowUpTypes.LOAD_FOLLOWUP_REQUEST, { patientId, paginator, filter }
    )
    
export const loadFollowUpSuccess = (response: IAxiosResponse<FollowUp[]>) => action(FollowUpTypes.LOAD_FOLLOWUP_SUCCESS, response)

export const loadFollowUpFailure = () => action(FollowUpTypes.LOAD_FOLLOWUP_FAILURE)

export const createFollowUpRequest = (patientId: string) => action(FollowUpTypes.CREATE_FOLLOWUP_REQUEST, { patientId })

export const createFollowUpSuccess = (response: IAxiosResponse<FollowUp>) => action(FollowUpTypes.CREATE_FOLLOWUP_SUCCESS, response)

export const createFollowUpFailure = () => action(FollowUpTypes.CREATE_FOLLOWUP_FAILURE)

export const findFollowUpRequest = (patientId: string, followUpId: string) =>
    action(FollowUpTypes.FIND_FOLLOWUP_REQUEST, { patientId, followUpId })

export const findFollowUpSuccess = (response: IAxiosResponse<FollowUp>) => action(FollowUpTypes.FIND_FOLLOWUP_SUCCESS, response)

export const findFollowUpFailure = () => action(FollowUpTypes.FIND_FOLLOWUP_FAILURE)

export const updateFollowUpRequest = (followUp: FollowUp) => action(FollowUpTypes.UPDATE_FOLLOWUP_REQUEST, { followUp })

export const updateFollowUpSuccess = (response: IAxiosResponse<FollowUp>) => action(FollowUpTypes.UPDATE_FOLLOWUP_SUCCESS, response)

export const updateFollowUpFailure = (e: any) => action(FollowUpTypes.UPDATE_FOLLOWUP_FAILURE, { e })

export const followUpAlertRequest = (
    date: string, paginator: IPaginator) => action(FollowUpTypes.FOLLOWUP_ALERT_REQUEST, { date, paginator })